// eslint-disable-next-line no-restricted-imports
import { connect as reduxConnect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const connect = (state, actions) =>
  typeof state === 'function' || state === null
    ? reduxConnect(state, actions)
    : reduxConnect(createStructuredSelector(state), actions);

export default connect;
